.header {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  flex-shrink: 0;
}

.title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.close {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #9ca3af;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
  transition: all 0.15s ease;

  &:hover {
    background-color: #f3f4f6;
    color: #1f2937;
  }
}